// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface ProductListFiltersWrapperStyles {
    wrapper?: InjectableCss;
}

export const productListFiltersWrapperStyles: ProductListFiltersWrapperStyles = {
    wrapper: {
        css: css`
            background: ${getColor("common.background")};
            border-radius: ${pxToRem(16)};
            padding: ${pxToRem(15)};
            margin-bottom: ${pxToRem(20)};
        `
    }
};

const styles = productListFiltersWrapperStyles;

const ProductListFiltersWrapper: FC<Props> = ({id}) => {

    return (
        <StyledWrapper {...styles.wrapper}>
           <Zone contentId={id} zoneName="Content00" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ProductListFiltersWrapper,
    definition: {
        group: "Product List",
        displayName: "Filters Wrapper",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
